
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 28 28","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"stroke":"#F7941E","stroke-width":"3","fill":"none","fill-rule":"evenodd","stroke-linecap":"square"}},[_c('path',{attrs:{"d":"M2 14h24M14 2v24"}})])])
      }
    
      }
    